import { gql } from "@apollo/client";

export const GetTimeClockEntriesPage = gql`
  query GetTimeClockEntriesPage(
    $pagination: PaginationInput!
    $locationId: String!
    $employeeId: String
  ) {
    timeClockEntryPage(
      pagination: $pagination
      locationId: $locationId
      employeeId: $employeeId
    ) {
      items {
        id
        employee {
          user {
            firstName
            lastName
          }
        }
        editedBy {
          user {
            firstName
            lastName
          }
        }
        editedAt
        updatedDate
        startedAt
        endedAt
        createdDate
      }
      totalRows
    }
  }
`;

export const GetTimeClockEntry = gql`
  query GetTimeClockEntry($id: String!) {
    timeClockEntryOne(id: $id) {
      id
      station {
        id
      }
      employee {
        id
      }
      startedAt
      endedAt
    }
  }
`;
